module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('OrderContentFramework', {
    attrs: {
      "button-name": '提交订单',
      "totalMoney": _vm.totalMoney,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.newsubmitOrder
    }
  }, [(!_vm.isService) ? _c('div', {
    staticClass: "content-block"
  }, [_c('img', {
    staticClass: "default-flag",
    attrs: {
      "src": "static/img/默认flag.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("收货地址")]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#979797"
    }
  }, [_vm._v("将商品留在吉凯用于其他项目")]), _vm._v(" "), _c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isExpress),
      expression: "isExpress"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isExpress) ? _vm._i(_vm.isExpress, null) > -1 : (_vm.isExpress)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isExpress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isExpress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isExpress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isExpress = $$c
        }
      }, _vm.changeExpressFree]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    style: ({
      'background-color': _vm.isExpress ? '#5878fa' : '#e5e5e5'
    })
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isExpress),
      expression: "!isExpress"
    }]
  }, [_c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), (_vm.deliverAddress) ? _c('router-link', {
    staticClass: "block-item",
    staticStyle: {
      "height": "81px"
    },
    attrs: {
      "to": {
        name: 'WeappAddress'
      }
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.deliverAddress.province + _vm.deliverAddress.city + (_vm.deliverAddress.district === undefined ? '' : _vm.deliverAddress.district) + _vm.deliverAddress.expressAddress))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.deliverAddress.consignee) + " " + _vm._s(_vm.deliverAddress.expressMobile))])])]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing light-text-color"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('label', {
    staticClass: "label-checkbox item-content",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "deliverMethod",
      "checked": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style",
    staticStyle: {
      "width": "20px",
      "height": "20px"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("顺丰快递")])])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [(_vm.isService) ? _c('ServiceProduct', {
    ref: "service",
    attrs: {
      "order": _vm.orderList,
      "service": _vm.isService
    },
    on: {
      "SE": _vm.getServiceTotalMoney
    }
  }) : _c('OrderMerchandises', {
    attrs: {
      "order": _vm.orderForMerchandises
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-item",
    on: {
      "click": _vm.goToSelectCoupons
    }
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v("优惠券")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [(!_vm.availableCoupons || _vm.availableCoupons.length === 0) ? _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("无可用")]) : (_vm.displayNameOnlyCoupon) ? _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("使用1张" + _vm._s(_vm.displayNameOnlyCoupon.label))]) : (_vm.selectedCoupons.length > 0) ? _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("已选择\n            "), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v(_vm._s(_vm.selectedCoupons.length))]), _vm._v("张优惠券，可抵扣\n            "), _c('span', {
    staticClass: "alert-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.couponDiscount)) + "元")])]) : _c('span', [_vm._v("未选择")]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing light-text-color"
  })])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb8fb74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Order/OrderContentConfirmation.vue
// module id = 1623
// module chunks = 8